import { z } from 'zod';
import { isoDateSchema } from './common.js';

/**
 * Typed-document store for regulator-critical paperwork. `expiresAt` feeds
 * the expiring-document cron (notifies PM 30/7/1 days ahead).
 */
export const attachmentKindSchema = z.enum([
  'contrato',
  'art',
  'alvara',
  'licenca',
  'cnpj',
  'nf',
  'boletim',
  'other',
]);
export type AttachmentKind = z.infer<typeof attachmentKindSchema>;

export const projectAttachmentSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  kind: attachmentKindSchema,
  r2Key: z.string(),
  filename: z.string(),
  mimeType: z.string(),
  sizeBytes: z.number().int().min(0),
  expiresAt: isoDateSchema.nullable(),
  uploadedBy: z.string(),
  uploadedByName: z.string(),
  uploadedAt: z.string(),
  /**
   * Wave 73 — Trena source tracking.
   * 'trena_stage0' = auto-registered when PM uploaded PDF during Trena Stage 0.
   * null = manual upload from /documentos UI.
   */
  source: z.string().nullable().optional(),
  /**
   * Wave 73 — estimate that first used this file as a source document.
   */
  trenaEstimateId: z.string().nullable().optional(),
});
export type ProjectAttachment = z.infer<typeof projectAttachmentSchema>;

export const requestAttachmentUploadRequestSchema = z.object({
  kind: attachmentKindSchema,
  filename: z.string().trim().min(1).max(255),
  mimeType: z.string().trim().min(1).max(200),
  sizeBytes: z.number().int().min(1).max(50 * 1024 * 1024), // 50MB cap
  expiresAt: isoDateSchema.optional(),
});
export type RequestAttachmentUploadRequest = z.infer<
  typeof requestAttachmentUploadRequestSchema
>;
